import React from 'react';
import RoutedTabs from 'src/components/routed-tabs';
import {Redirect, Route, Switch} from 'react-router-dom';
import ForbesRanks from '../forbes-ranks';
import UsNewsRanks from '../us-news-ranks';

const tabs = [
  {label: 'Forbes', path: '/forbes'},
  {label: 'US News', path: '/us-news'},
];

const CollegeRanks = (): React.ReactElement => (
  <div>
    <RoutedTabs tabs={tabs} className="text-center" />
    <Switch>
      <Route path="/admin/tools/college-ranks/forbes" component={ForbesRanks} />
      <Route path="/admin/tools/college-ranks/us-news" component={UsNewsRanks} />
      <Redirect path="*" to="/admin/tools/college-ranks/forbes" />
    </Switch>
  </div>
);

export default CollegeRanks;
